import CB_VERSION_TYPE from '@/app/modules/contracts/enums/CbVersionType';
import APPLICATIONS from '@/app/modules/contracts/enums/ItpRegex';
import REMOTE_COLLECTION_RECONCILIATION_CODE from '../enums/RemoteCollectionReconciliationCode';
import { nsContract, nsRemoteCollection, nsTerminal } from '@/app/i18n/namespaces';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

export default {
    UUID: {
        key: 'uuid'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.created_at',
        namespace: nsRemoteCollection,
        filter: FILTER_TYPES.DATE,
        enableSorting: false
    },
    RECONCILIATION_NUMBER: {
        key: 'reconciliationNumber',
        entity: 'keys.reconciliation_number',
        namespace: nsRemoteCollection,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.reconciliation_number',
        enableSorting: false,
        isNested: true
    },
    MESSAGES_NUMBER: {
        key: 'messagesNumber',
        entity: 'keys.messages_number',
        namespace: nsRemoteCollection,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.messages_number',
        enableSorting: false
    },
    ERT: {
        key: 'ert',
        entity: 'remoteCollection_ert'
    },
    LOCAL_TRANSACTION_DATE_TIME: {
        key: 'localTransactionDateTime',
        type: FIELD_TYPES.DATE,
        entity: 'keys.transaction_date',
        namespace: nsRemoteCollection,
        filter: FILTER_TYPES.DATE,
        isLocalDateAndTime: true,
        enableSorting: false
    },
    RECONCILIATION_CODE: {
        key: 'reconciliationCode',
        prefix: 'remoteCollection_reconciliation_code_',
        entity: 'keys.reconciliation_code',
        namespace: nsRemoteCollection,
        filter: FILTER_TYPES.SELECT,
        enum: REMOTE_COLLECTION_RECONCILIATION_CODE,
        enableSorting: false
    },
    CREDITS_NUMBER: {
        key: 'creditsNumber',
        entity: 'remoteCollection_credits_number'
    },
    DEBITS_NUMBER: {
        key: 'debitsNumber',
        entity: 'remoteCollection_debits_number'
    },
    DEBITS_REVERSAL_NUMBER: {
        key: 'debitsReversalNumber',
        entity: 'remoteCollection_debits_reversal_number'
    },
    NON_COMPLETED_NUMBER: {
        key: 'nonCompletedNumber',
        entity: 'remoteCollection_non_completed_number'
    },
    CREDITS_AMOUNT: {
        key: 'creditsAmount',
        entity: 'remoteCollection_credits_amount'
    },
    DEBITS_AMOUNT: {
        key: 'debitsAmount',
        entity: 'remoteCollection_debits_amount'
    },
    DEBITS_REVERSAL_AMOUNT: {
        key: 'debitsReversalAmount',
        entity: 'remoteCollection_debits_reversal_amount'
    },
    TOTAL_AMOUNT: {
        key: 'totalAmount',
        entity: 'keys.total_amount',
        namespace: nsRemoteCollection,
        filter: FILTER_TYPES.NUMBER,
        placeholder: 'filter.placeholder.total_amount',
        enableSorting: false
    },
    TOTAL_REVENUE: {
        key: 'totalAmountsSum',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.total_revenue',
        namespace: nsRemoteCollection
    },
    CONTRACT: {
        key: 'contract',
        entity: 'keys.contract_number',
        namespace: nsContract,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.contract',
        enableSorting: false
    },
    RANK: {
        key: 'rank',
        entity: 'keys.rank',
        namespace: nsContract,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.rank',
        enableSorting: false
    },
    ITP: {
        key: 'itp',
        entity: 'remoteCollection_itp'
    },
    CURRENCY: {
        key: 'currency',
        entity: 'remoteCollection_currency'
    },
    MCC: {
        key: 'mcc',
        entity: 'remoteCollection_mcc'
    },
    BANK_CODE: {
        key: 'bankCode',
        entity: 'keys.bank_code',
        namespace: nsContract,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.bank_code',
        enableSorting: false
    },
    REGISTRATION_NUMBER: {
        key: 'registrationNumber',
        entity: 'keys.registration_number',
        namespace: nsContract,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.registration_number',
        enableSorting: false
    },
    APPLICATION: {
        key: 'application',
        entity: 'keys.application',
        namespace: nsContract,
        filter: FILTER_TYPES.SELECT,
        enum: APPLICATIONS,
        enableSorting: false,
        sortOptions: true
    },
    LEGAL_NAME: {
        key: 'legalName',
        entity: 'keys.legal_name',
        namespace: nsRemoteCollection,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.legal_name',
        enableSorting: false
    },
    TRANSACTION_COUNT: {
        key: 'transactionCount',
        entity: 'keys.transaction_count',
        namespace: nsRemoteCollection,
        filter: FILTER_TYPES.NUMBER,
        placeholder: 'filter.placeholder.transaction_count',
        enableSorting: false
    },
    CB_VERSION: {
        key: 'cbVersion',
        type: FIELD_TYPES.TEXT,
        prefix: 'cbVersionType_',
        entity: 'keys.cb_version',
        namespace: nsContract,
        filter: FILTER_TYPES.SELECT,
        enum: CB_VERSION_TYPE,
        enableSorting: false
    },
    POS_TERMINAL: {
        key: 'posTerminal',
        UUID: {
            parentKeys: ['posTerminal'],
            key: 'uuid'
        },
        SERIAL_NUMBER: {
            parentKeys: ['posTerminal'],
            key: 'serialNumber',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.serial_number',
            namespace: nsTerminal,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.serial_number',
            enableSorting: false,
            isNested: true
        },
        MANUFACTURER: {
            parentKeys: ['posTerminal'],
            key: 'manufacturer',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.manufacturer',
            namespace: nsTerminal,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.manufacturer',
            enableSorting: false,
            isNested: true
        },
        LABEL: {
            parentKeys: ['posTerminal'],
            key: 'label',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.label',
            namespace: nsTerminal,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.label',
            enableSorting: false,
            isNested: true
        },
        CUSTOM_LABEL: {
            parentKeys: ['posTerminal'],
            key: 'customLabel',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.custom_label',
            namespace: nsTerminal,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.custom_label',
            enableSorting: false,
            isNested: true
        }
    },
    SUBSCRIPTION: {
        key: 'subscription'
    },
    POS_REMITTANCE_NUMBER: {
        key: 'posRemittanceNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.remittance_number',
        namespace: nsRemoteCollection,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.remittance_number',
        enableSorting: false
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    }
};